import { useState, useCallback } from 'react'
import axios from 'axios'

export default function useStudentNameSearch(facilityId) {
  const [matches, setMatches] = useState([])
  const [isSearching, setIsSearching] = useState(false)

  const searchByName = useCallback(async (name) => {
    const trimmed = (name || '').trim()
    const parts = trimmed.split(/\s+/).filter(Boolean)
    if (parts.length < 2 || trimmed.length < 3) {
      setMatches([])
      return
    }
    setIsSearching(true)
    try {
      const response = await axios.get(
        `/api/facilities/${facilityId}/students/name_search`,
        { params: { q: trimmed } }
      )
      setMatches(response.data || [])
    } catch (err) {
      console.error('useStudentNameSearch error:', err)
      setMatches([])
    } finally {
      setIsSearching(false)
    }
  }, [facilityId])

  const clearMatches = useCallback(() => {
    setMatches([])
  }, [])

  return { matches, isSearching, searchByName, clearMatches }
}
